import _objectWithoutProperties from "/Users/jakubpsenda/jakub/projekty/projekty/gatsby_martin_github/video/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/Users/jakubpsenda/jakub/projekty/projekty/gatsby_martin_github/video/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["className", "children", "transitionClasses"];

var _fadeStyles;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import * as React from 'react';
import { useCallback } from 'react';
import { ENTERED, ENTERING } from 'react-transition-group/Transition';
import transitionEndListener from './transitionEndListener';
import triggerBrowserReflow from './triggerBrowserReflow';
import TransitionWrapper from './TransitionWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var fadeStyles = (_fadeStyles = {}, _defineProperty(_fadeStyles, ENTERING, 'show'), _defineProperty(_fadeStyles, ENTERED, 'show'), _fadeStyles);
var Fade = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      _children = _ref.children,
      _ref$transitionClasse = _ref.transitionClasses,
      transitionClasses = _ref$transitionClasse === void 0 ? {} : _ref$transitionClasse,
      props = _objectWithoutProperties(_ref, _excluded);

  var handleEnter = useCallback(function (node, isAppearing) {
    triggerBrowserReflow(node);
    props.onEnter == null ? void 0 : props.onEnter(node, isAppearing);
  }, [props]);
  return /*#__PURE__*/_jsx(TransitionWrapper, _objectSpread(_objectSpread({
    ref: ref,
    addEndListener: transitionEndListener
  }, props), {}, {
    onEnter: handleEnter,
    childRef: _children.ref,
    children: function children(status, innerProps) {
      return /*#__PURE__*/React.cloneElement(_children, _objectSpread(_objectSpread({}, innerProps), {}, {
        className: classNames('fade', className, _children.props.className, fadeStyles[status], transitionClasses[status])
      }));
    }
  }));
});
Fade.defaultProps = defaultProps;
Fade.displayName = 'Fade';
export default Fade;